import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  CanActivateFn,
  GuardResult,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthService } from '@app/services/auth.service';

function guardRoute(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
  const authService = inject(AuthService);
  const router = inject(Router);

  return new Promise<GuardResult>((res) => {
    authService.init$.subscribe({
      error: () => {
        res(false);
      },
      next: (init) => {
        if (!init) return;

        const account = authService.getUser();
        let result: GuardResult = true;

        if (!account.id) {
          result = router.createUrlTree(['/signin'], {
            queryParams: { redirect: state.url },
          });
        } else if (!account.verified) {
          result = router.createUrlTree(['/verify']);
        }

        res(result);
      },
    });
  });
}

export const authGuard: CanActivateFn = guardRoute;
export const authGuardChild: CanActivateChildFn = guardRoute;
